// index-scripts.js

// Sticky header
let last_scroll;
window.onscroll = function(e) {
    const utility_bar = document.querySelector('.utility-bar');
    const h = document.querySelector('header.site-header');

    if (last_scroll !== undefined) {
        if (window.scrollY < last_scroll) {
            // Up
            h.classList.add('white_bg');
            h.style.background = '#fff';
            h.classList.remove('down');
            utility_bar.classList.remove('down');
        } else {
            // Down
            h.classList.add('white_bg');
            utility_bar.classList.add('down');
            h.classList.add('down');
        }
    }

    if (window.scrollY === 0) {
        h.classList.remove('white_bg');
        h.style.background = 'transparent';
    }

    last_scroll = window.scrollY;
}

document.addEventListener("DOMContentLoaded", function() {

    // Extra Mega Menu Header
    function extra_mega_menu_items() {
        const menuContainers = document.querySelectorAll('.h2m-menu-container');
        if (menuContainers.length > 0) {
            menuContainers.forEach(function(item) {
                item.addEventListener('mouseover', function() {
                    const header = document.querySelector('.template-index header.site-header');
                    if (header) {
                        header.style.background = '#fff';
                        header.classList.add('_menu_hover');
                    }
                });
                item.addEventListener('mouseleave', function() {
                    const header = document.querySelector('.template-index header.site-header');
                    if (header) {
                        header.style.background = 'transparent';
                        header.classList.remove('_menu_hover');
                    }
                });
            });
        }
    }

    // Вызов функции с задержкой
    const delays = [1000, 3000, 5000, 7000, 9000, 11000, 13000, 15000, 17000, 19000, 21000, 23000];
    delays.forEach(function(delay) {
        setTimeout(extra_mega_menu_items, delay);
    });

    // Наблюдатель за изменениями в навигации
    const homeNav = document.querySelector('.template-index .site-header .site-navigation > ul');
    const MutObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    if (MutObserver && homeNav) {
        const homeNavObserver = new MutObserver(function(mutationRecords) {
            mutationRecords.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(n) {
                    if (n instanceof HTMLElement) {
                        extra_mega_menu_items();
                    }
                });
            });
        });
        homeNavObserver.observe(homeNav, {
            childList: true,
            characterDataOldValue: true,
            attributes: true
        });
    }

    // Homepage Banner - Slider
    const maxWidth = 768; // Убедитесь, что переменная maxWidth определена
    const slideshowSection = document.querySelector('#shopify-section-static-slideshow');
    if (slideshowSection) {
        const bgDivs = slideshowSection.querySelectorAll('.slideshow-background');
        const flickityDots = slideshowSection.querySelector('.flickity-page-dots');

        bgDivs.forEach(function(bg) {
            const desktopImage = bg.querySelector('.desktop-slideshow-image');
            if (desktopImage) {
                let desktopInitSrc = desktopImage.getAttribute('data-rimg-template');
                desktopInitSrc = desktopInitSrc.replace(/\{size\}/, '1488x449');
                desktopImage.setAttribute('data-desktopimg-src', desktopInitSrc);
            }
        });

        function checkWidth() {
            if (window.innerWidth <= maxWidth) {
                bgDivs.forEach(function(bg) {
                    const mobileImage = bg.querySelector('.mobile-slideshow-image');
                    if (mobileImage) {
                        bg.style = '';
                    }
                });

                if (!slideshowSection.classList.contains('mobile-ver')) {
                    slideshowSection.classList.add('mobile-ver');
                }
            } else {
                if (slideshowSection.classList.contains('mobile-ver')) {
                    bgDivs.forEach(function(bg) {
                        const desktopImage = bg.querySelector('.desktop-slideshow-image');
                        if (desktopImage) {
                            const desktopSrc = desktopImage.getAttribute('data-desktopimg-src');
                            if (desktopSrc) {
                                bg.style = `background-image: url("${desktopSrc}");`;
                            }
                        }
                    });
                    slideshowSection.classList.remove('mobile-ver');
                }
            }
        }

        checkWidth();
        window.addEventListener('resize', checkWidth);
    }
    // End of Homepage Banner - Slider

});
